import * as React from 'react';
import { Toaster as Sonner, type ToasterProps } from 'sonner';

/**
 * App-wide toast container.
 *
 * Mounted once in main.tsx. Toasts are then triggered from anywhere via
 * the `toast` function from `sonner`:
 *
 *   import { toast } from 'sonner';
 *   toast.success('Saved');
 *
 * `richColors` gives the typed variants (success / error / warning / info)
 * their themed background colors instead of a plain neutral surface.
 */
const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      richColors
      position="bottom-right"
      className="toaster group"
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
